export default __webpack_public_path__ + "static/media/new_level_arrow.f3a4ccf2.svg";